import { MoreVert } from '@mui/icons-material';
import { Box, Menu, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import { FC, MouseEvent, ReactNode, useState } from 'react';

interface ItemMenuProps {
    items: Array<{
        label: string;
        icon?: ReactNode;
        onClick: () => void;
    }>
}

type Props = ItemMenuProps;


const ItemMenu: FC<Props> = (props: Props) => {
    const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);

    const handleOpenNavMenu = (event: MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    return <Box color="#9ba7b3">
        <IconButton
            size="small"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="inherit"
        >
            <MoreVert />
        </IconButton>
        <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}

        >

            {props.items.map(item => <MenuItem key={item.label}
                onClick={() => {
                    handleCloseNavMenu();
                    item.onClick();
                }}
            >
                {item.icon && item.icon}
                <Typography textAlign="center" fontFamily="Montserrat" ml={1}>{item.label}</Typography>
            </MenuItem>)}

        </Menu>
    </Box>;
}


export default ItemMenu;

